import React, { Component } from 'react';

class Footer extends Component {
  render(){

    return(
      <footer>
        <div className="row">
          <div className="large-6 columns">
            <p>&copy; COPYRIGHT 2018 ANDY YEO</p>
            
          </div>
          <div className="large-6 columns">
            
            <p className="credits">a <a href="http://www.winkletwebdesign.com" rel="noopener noreferrer" target="_blank">Winklet Web Design</a> website</p>
          </div>
        </div>
        
      </footer>
    );
  }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/modules/sections/Footer.js